<template><TicketConversation /></template>
<script>
import TicketConversation from './TicketConversation.vue';
export default { components: { TicketConversation } };
</script>
